import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal } from 'tea-component';
import { useIntl } from 'umi';
import { FUNCOM_CARD_LIST } from '../../_config/config';
import { getName } from '@home/utils/common';
import OpinionsPreviewTitle from '../OpinionsPreviewTitle';
import { downPreviewImg } from '../../utils';
import './index.scss';

interface IOpinionsPreViewModalProps {
  visible: boolean;
  selectCard: string[];
  filter: any;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

const OpinionsPreViewModal = (props: IOpinionsPreViewModalProps) => {
  const { visible, setVisible, selectCard } = props || {};

  const [loading, setLoading] = useState(false);

  const pageRef = useRef(null);

  // 获取所有卡片模块
  const selectCardList = FUNCOM_CARD_LIST.filter((item) =>
    selectCard.includes(item.value),
  );

  const { formatMessage } = useIntl();

  const onClose = () => {
    setVisible(false);
  };

  const downImg = async () => {
    setLoading(true);
    try {
      const node: any = pageRef.current;
      await downPreviewImg({
        node,
        fileName: '自动化报告',
      });
      setLoading(false);
    } catch (error) {
      console.log('★ ~ 图片生成失败>>', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    selectCardList.forEach((item) => {
      const { value, components } = item;
      const parentNode = document.getElementById(value);
      components.forEach((id) => {
        if (id) {
          const node = document.getElementById(id);
          if (node) {
            parentNode?.appendChild(node);
          }
        }
      });
    });
  }, []);

  return (
    <Modal
      visible={visible}
      onClose={onClose}
      size="100%"
      caption={formatMessage({ id: 'metrics_setting_title' })}
    >
      <Modal.Body>
        <div ref={pageRef} className="dbh-studio-opinions-preview-page">
          <div className="dbh-studio-opinions-preview-page-modal"></div>
          <div className="dbh-studio-opinions-preview-page-bg">
            <div className="dbh-studio-opinions-preview-page-bg-modal">
              <div className="dbh-studio-opinions-preview-page-cover">
                <img />
              </div>
              <div className="dbh-studio-opinions-preview-page-content">
                {selectCardList.map((item) => {
                  const { nameCn, nameEn, value } = item;
                  return (
                    <div id={value} key={value}>
                      <OpinionsPreviewTitle
                        title={getName(true, nameEn, nameCn)}
                      />
                    </div>
                  );
                  // if (components?.length > 0) {
                  //   return (
                  //     <div key={value}>
                  //       {
                  //         components.map(Com => {
                  //           if (Com) {
                  //             return <Com key={value + nameEn} filter={filter} />;
                  //           }
                  //           return null;
                  //         })
                  //       }
                  //     </div>
                  //   );
                  // }
                  // return null;
                })}
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button type="primary" onClick={downImg as any} loading={loading}>
          {formatMessage({ id: 'common_confirm' })}
        </Button>
        <Button type="weak" onClick={onClose}>
          {formatMessage({ id: 'common_cancel' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OpinionsPreViewModal;
